import * as React from 'react';
import { Option } from '@webapp/types/common/option';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';
import Typography from '@components/basics/typography';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import { easeTransition } from '@components/framer';

interface InputTabSelectorProps {
  id?: string;
  className?: string;
  value: string;
  options: Option[];
  isDisabled: boolean;
  isMobile?: boolean;
  onClick: (value: any) => void;
}

const mapStatetoProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const InputTabSelector: React.FC<InputTabSelectorProps> = ({
  id,
  className,
  value,
  options,
  isDisabled,
  isMobile,
  onClick,
}) => {
  return (
    <Container id={id} className={className}>
      <AnimatePresence>
        {options.map((option) => (
          <motion.div
            key={option.value}
            initial={{ scale: 1 }}
            whileHover={
              !isDisabled && value !== option.value
                ? { scale: 1.075 }
                : undefined
            }
            transition={{ ...easeTransition }}
          >
            <Text
              className={`${isDisabled ? 'disabled' : ''} ${
                value === option.value ? 'selected' : ''
              }`}
              weight="700"
              uppercase
              type={isMobile ? 'small' : undefined}
              onClick={() => onClick(option.value)}
              opacity={value === option.value ? '1' : '.5'}
            >
              {option.label}
            </Text>
          </motion.div>
        ))}
      </AnimatePresence>
    </Container>
  );
};

export default connect(mapStatetoProps)(InputTabSelector);

const Container = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.inputBackground};
  border-radius: 0 4px 4px 0;
  height: 48px;
  max-height: 48px;
  padding: 0 8px;
  gap: 8px;

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    gap: 10px;
    padding: 0 18px;
    height: 60px;
    max-height: 60px;
  }
`;

const Text = styled(Typography)`
  cursor: pointer;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 1;
  }

  &.disabled,
  &.selected {
    pointer-events: none;
  }
`;
